// import React, { useEffect, useState } from "react";
// import { NavLink, useLocation } from "react-router-dom";
// import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
// // import "react-pro-sidebar/dist/css/styles.css";

// import useHttp from "../hooks/use-http";
// import "./sidebar.css";

// const SidebarComponent = () => {

//   const location = useLocation();
//   const [menusData, setMenusData] = useState([]);
//   const [activeMenu, setActiveMenu] = useState("home");
//   const [activeSubMenu, setActiveSubMenu] = useState(null);
//   const url = localStorage.getItem("organizationIcon");
//   const { sendRequest: getServiceData } = useHttp();

//   const serviceMenuData = () => {
//     getServiceData(
//       {
//         url: `/api/menuServiceRoleAllocation/?userId=${localStorage.getItem(
//           "id"
//         )}`,
//       },
//       (data) => {
//         const menuData = data.output;
//         localStorage.setItem("userMenu", JSON.stringify(menuData));
//         setMenusData(menuData);
//         console.log(menuData);
//       }
//     );
//   };

//   useEffect(() => {
//     serviceMenuData();
//   }, [getServiceData]);

//   const handleMenuClick = (menuIndex) => {
//     setActiveMenu(menuIndex === activeMenu ? null : menuIndex);
//     setActiveSubMenu(null); 
//   };

//   const handleSubMenuClick = (menuIndex, subMenuIndex) => {
//     setActiveMenu(menuIndex);
//     setActiveSubMenu(subMenuIndex === activeSubMenu ? null : subMenuIndex);
//   };



//   return (
//     <Sidebar className="sidebar-dark-primary main-sidebar">
//       <NavLink to="/orgProfile" className="brand-link">
//         <img
//           src={`${process.env.REACT_APP_FILE_URL}${url}`}
//           alt="Logo"
//           className="brand-image img-circle elevation-3"
//           style={{ opacity: ".8" }}
//         />
//         <span className="text-dark">
//           {localStorage.getItem("organizationName")}
//         </span>
//       </NavLink>

//       <Menu iconShape="circle">
//         <NavLink to="/" className="text-dark">
//           <MenuItem
//             label={
//               <NavLink to="/" className="text-bold">
//                 Home
//               </NavLink>
//             }
//             icon={<i className="nav-icon fas fa-home" />}
//             active={activeMenu === "home"}
//             onClick={() => setActiveMenu("home")}
//           >
//             Home
//           </MenuItem>
//         </NavLink>
//         {menusData.map((menu, menuIndex) => (
//           <SubMenu
//             key={menuIndex}
//             label={menu.title}
//             icon={<i className={`nav-icon ${menu.url}`} />}
//             onOpenChange={() => handleMenuClick(menuIndex)}
//             open={activeMenu === menuIndex}
//           >
//             {menu.menuItemList &&
//               menu.menuItemList.map((menuItem, subMenuIndex) => (
//                 <SubMenu
//                   key={subMenuIndex}
//                   label={menuItem.menuTittle}
//                   style={{ marginLeft: "-20px" }}
//                   icon={<i className={`nav-icon far fa-circle text-success`} />}
//                   onOpenChange={() =>
//                     handleSubMenuClick(menuIndex, subMenuIndex)
//                   }
//                   open={
//                     activeSubMenu === subMenuIndex && activeMenu === menuIndex
//                   }
//                 >
//                   {menuItem.subItemList &&
//                     menuItem.subItemList.map((menusubItem, i) => (
//                       <NavLink to={menusubItem.menuUrl}>
//                         <MenuItem key={i}>
//                           <i className="nav-icon far fa-circle text-info mx-1"></i>
//                           {menusubItem.menuTittle}
//                         </MenuItem>
//                       </NavLink>
//                     ))}
//                 </SubMenu>
//               ))}
//           </SubMenu>
//         ))}
//       </Menu>

//       <div className="text-center mb-2">
//         <img
//           src="dist/img/logo.png"
//           height="50"
//           width="50"
//           alt="AdminLTE Logo"
//           className="brand-image img-circle elevation-3"
//           style={{ opacity: ".8" }}
//         />
//         <br />
//         <span className="brand-text">Powered By</span>
//       </div>
//     </Sidebar>
//   );
// };

// export default SidebarComponent;

import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import useHttp from "../hooks/use-http";
import "./sidebar.css";

const SidebarComponent = () => {
  const location = useLocation();
  const [menusData, setMenusData] = useState([]);
  const [activeMenu, setActiveMenu] = useState("home");
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const url = localStorage.getItem("organizationIcon");
  const { sendRequest: getServiceData } = useHttp();

  const serviceMenuData = () => {
    getServiceData(
      {
        url: `/api/menuServiceRoleAllocation/?userId=${localStorage.getItem("id")}`,
      },
      (data) => {
        const menuData = data.output;
        localStorage.setItem("userMenu", JSON.stringify(menuData));
        setMenusData(menuData);
        setActiveItemsFromPath(menuData, location.pathname); // 👈 Add this line
      }
    );
  };

  useEffect(() => {
    serviceMenuData();
  }, [getServiceData]);

  useEffect(() => {
    setActiveItemsFromPath(menusData, location.pathname);
  }, [location.pathname, menusData]);

  const setActiveItemsFromPath = (menus, pathname) => {
    menus.forEach((menu, menuIndex) => {
      menu.menuItemList?.forEach((menuItem, subMenuIndex) => {
        menuItem.subItemList?.forEach((subItem) => {
          if (pathname === subItem.menuUrl) {
            setActiveMenu(menuIndex);
            setActiveSubMenu(subMenuIndex);
          }
        });
      });
    });
  };

  const handleMenuClick = (menuIndex) => {
    setActiveMenu(menuIndex === activeMenu ? null : menuIndex);
    setActiveSubMenu(null);
  };

  const handleSubMenuClick = (menuIndex, subMenuIndex) => {
    setActiveMenu(menuIndex);
    setActiveSubMenu(subMenuIndex === activeSubMenu ? null : subMenuIndex);
  };


  return (
    <Sidebar className="sidebar-dark-primary main-sidebar" style={{ display: "flex", flexDirection: "column", height: "100vh" }}>

      {/* Logo / Company Name */}
      <NavLink
        to="/orgProfile"
        className="brand-link"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "15px 0",
          textAlign: "center",
        }}
      >
        <img
          src={`${process.env.REACT_APP_FILE_URL}${url}`}
          alt="Logo"
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "60%",
            marginBottom: "8px",
            marginLeft: "10px"
          }}
        />
        <span
          className="text-dark"
          style={{ fontWeight: "600", fontSize: "15px" }}
        >
          {localStorage.getItem("organizationName")}
        </span>
      </NavLink>

      {/* SCROLL AREA */}
      <div style={{ flex: 1, overflowY: "auto" }}>
        <Menu iconShape="circle">

          {/* Home */}
          <NavLink to="/" className="text-dark">
            <MenuItem
              icon={<i className="nav-icon fas fa-home" />}
              active={activeMenu === "home"}
              onClick={() => setActiveMenu("home")}
            >
              Home
            </MenuItem>
          </NavLink>

          {/* Dynamic Menus */}
          {menusData.map((menu, menuIndex) => (
            <SubMenu
              key={menuIndex}
              label={menu.title}
              icon={<i className={`nav-icon ${menu.url}`} />}
              onOpenChange={() => handleMenuClick(menuIndex)}
              open={activeMenu === menuIndex}
            >
              {menu.menuItemList?.map((menuItem, subMenuIndex) => (
                <SubMenu
                  key={subMenuIndex}
                  label={menuItem.menuTittle}
                  style={{ marginLeft: "-20px" }}
                  icon={<i className="nav-icon far fa-circle text-success" />}
                  onOpenChange={() =>
                    handleSubMenuClick(menuIndex, subMenuIndex)
                  }
                  open={
                    activeSubMenu === subMenuIndex &&
                    activeMenu === menuIndex
                  }
                >
                  {menuItem.subItemList?.map((menusubItem, i) => (
                    <NavLink to={menusubItem.menuUrl} key={i}>
                      <MenuItem
                        active={location.pathname === menusubItem.menuUrl}
                      >
                        <i className="nav-icon far fa-circle text-info mx-1"></i>
                        {menusubItem.menuTittle}
                      </MenuItem>
                    </NavLink>
                  ))}
                </SubMenu>
              ))}
            </SubMenu>
          ))}
        </Menu>
      </div>

      {/* FIXED FOOTER */}
      <div
        style={{
          padding: "15px 0",
          textAlign: "center",
          background: "#d3d3d3"
        }}
      >
        <img
          src="dist/img/logo.png"
          height="55"
          width="55"
          alt="AdminLTE Logo"
          style={{
            borderRadius: "50%",
            marginBottom: "6px",
            display: "block",
            marginLeft: "auto",
            marginRight: "auto"
          }}
        />

        <span
          style={{
            fontWeight: "700",
            fontSize: "14px",
            color: "#000000ff",
            display: "block",
            marginTop: "5px"
          }}
        >
          Powered By FarmMobi
        </span>
      </div>

    </Sidebar>
  );
};

export default SidebarComponent;

